<div class="ltms-description">{{ mainDiscription }}</div>
<div class="action-main-container">
    <div class="action-left-container">
        <div>
            <app-action-tat-overall [totalResponses]="totalResponses" [totalActionableResponses]="totalActionableResponses"></app-action-tat-overall>
        </div>
        <div>
            <app-action-tat-hierarchy [overallData]="overallData" [componentId]="overallData.elementId" (onDrilldownChange)="onDrilldownChange($event)"></app-action-tat-hierarchy>
        </div>
    </div>
    <div class="action-right-container">
        <div>
            <app-action-tat-histogram [filters]="filters" [componentId]="histogramChartId"></app-action-tat-histogram>
        </div>
        <div>
            <app-action-tat-category-charts [filters]="filters" [componentId]="categoryChartId"></app-action-tat-category-charts>
        </div>
    </div>

</div>
